var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "nsSlottedDropdown",
      staticClass: "ns-slotted-dropdown",
      class: {
        disabled: _vm.disabled,
        "inline-label": _vm.inlineLabel,
        "auto-width": _vm.localWidth,
        nsd__small: _vm.size === "small"
      }
    },
    [
      _vm.label
        ? _c(
            "div",
            {
              staticClass: "form-label",
              class: { "label-error": _vm.errorMessage }
            },
            [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", [
        _c(
          "div",
          {
            staticClass: "dropdown-area",
            class: { "open-up": _vm.openUp },
            style: { width: _vm.localWidth },
            on: { mouseleave: _vm.closeDropdown }
          },
          [
            _c(
              "div",
              {
                staticClass: "current-selection",
                class: {
                  "form-error": _vm.invalid || _vm.errorMessage,
                  tall: _vm.tall,
                  opened: _vm.opened && !_vm.useModal
                },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.toggle($event)
                  }
                }
              },
              [
                (_vm.lockPlaceholder || _vm.selectedEmpty) && !_vm.selectedHtml
                  ? _c(
                      "div",
                      {
                        staticClass: "selected-item placeholder",
                        class: { "multi-line": _vm.multiLine }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.placeholder) +
                            "\n        "
                        )
                      ]
                    )
                  : _vm.showCustomSelectedItem
                  ? _c(
                      "div",
                      {
                        staticClass: "selected-item",
                        class: { "multi-line": _vm.multiLine }
                      },
                      [_vm._t("custom")],
                      2
                    )
                  : _c("div", {
                      staticClass: "selected-item",
                      class: { "multi-line": _vm.multiLine },
                      domProps: { innerHTML: _vm._s(_vm.selectedHtml) }
                    }),
                _vm._v(" "),
                !_vm.showCustomSelectedItem
                  ? _c("NsIcon", {
                      staticClass: "arrow-icon",
                      class: { opened: _vm.opened && !_vm.useModal },
                      attrs: { "icon-name": "icon-narrow-angle-bottom-24" }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            !_vm.useModal
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.opened,
                        expression: "opened"
                      }
                    ],
                    staticClass: "dropdown-content"
                  },
                  [
                    _vm._t("dropdown-content", [
                      _c(
                        "div",
                        {
                          ref: "list",
                          staticClass: "content-wrapper-mouse-helper"
                        },
                        [
                          _c(
                            "NsSlottedDropdownItems",
                            {
                              attrs: {
                                selected: _vm.selectedValue,
                                "show-all": _vm.showAll,
                                dense: _vm.denseList,
                                "using-custom": _vm.showCustomSelectedItem
                              },
                              on: { select: _vm.handleSelect }
                            },
                            [_vm._t("default")],
                            2
                          )
                        ],
                        1
                      )
                    ])
                  ],
                  2
                )
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c(
          "p",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errorMessage || _vm.invalid,
                expression: "errorMessage || invalid"
              }
            ],
            staticClass: "error-tag",
            class: { "no-absolute": _vm.errorNoAbsolute }
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.errorMessage || _vm.requiredMessage) +
                "\n    "
            )
          ]
        )
      ]),
      _vm._v(" "),
      _vm.useModal
        ? _c(
            "div",
            { ref: "modal" },
            [
              _c(
                "NsSlottedDropdownModal",
                {
                  attrs: {
                    open: _vm.opened,
                    title: _vm.label,
                    selected: _vm.selectedValue,
                    translations: _vm.translations,
                    "using-custom": _vm.showCustomSelectedItem,
                    "error-message":
                      _vm.errorMessage ||
                      (_vm.invalid && _vm.requiredMessage) ||
                      ""
                  },
                  on: { select: _vm.handleSelect, close: _vm.close },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "custom",
                        fn: function() {
                          return [_vm._t("custom")]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    true
                  )
                },
                [_vm._t("default")],
                2
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }